import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
import Header from "./../header/Header.vue";
import Footer from "./../footer/Footer.vue";
import moment from "moment";

export default {
  name: "Timeline",
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    Header,
    Footer
  },
  data() {
    return {
      dialog: false,
      timelineData: [],
      timlineDate: [],
      timelineArray: [
        // {
        //   month: 0,
        //   displayedMonth: "I",
        //   data: { eventDate: [], eventTitle: [], eventInfo: [] }
        // },
        {
          month: 1,
          displayedMonth: "II",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 2,
          displayedMonth: "III",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 3,
          displayedMonth: "IV",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 4,
          displayedMonth: "V",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 5,
          displayedMonth: "VI",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 6,
          displayedMonth: "VII",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 7,
          displayedMonth: "VIII",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 8,
          displayedMonth: "IX",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 9,
          displayedMonth: "X",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 10,
          displayedMonth: "XI",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        },
        {
          month: 11,
          displayedMonth: "XII",
          data: { eventDate: [], eventTitle: [], eventInfo: [] }
        }
      ],
      eventMonth: "",
      moreInfoDate: "",
      moreInfoTitle: "",
      moreInfoInfo: "",
      hooperSettings: {
        itemsToShow: 2,
        trimWhiteSpace: true,
        breakpoints: {
          2000: {
            itemsToShow: 4
          },
          1400: {
            itemsToShow: 3
          },
          500: {
            itemsToShow: 2
          },
          450: {
            itemsToShow: 1
          },
          0: {
            itemsToShow: 1
          }
        }
      },
      firstThreeEvents: [
        {
          month: 1,
          displayedMonth: "II",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 2,
          displayedMonth: "III",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 3,
          displayedMonth: "IV",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 4,
          displayedMonth: "V",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 5,
          displayedMonth: "VI",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 6,
          displayedMonth: "VII",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 7,
          displayedMonth: "VIII",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 8,
          displayedMonth: "IX",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 9,
          displayedMonth: "X",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 10,
          displayedMonth: "XI",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        },
        {
          month: 11,
          displayedMonth: "XII",
          data: { eventDate: [], eventTitle: [], eventInfo: [], hideBtn: true }
        }
      ],
      eventList: ""
    };
  },
  methods: {
    getData() {
      this.$http
        .get(
          "https://app.umw.edu.pl/headless/wp-json/tribe/events/v1/events?start_date=2020-01-01&per_page=100"
        )
        .then(function(data) {
          this.timelineData = JSON.parse(JSON.stringify(data)).body.events;
          this.prepareProperMonth();
          console.log(this.timelineData);

          window.scrollTo({ top: 0, behavior: "smooth" });
        });
    },

    diplayOnlyFirstThreeEvents() {
      var index = 0;

      this.timelineArray.forEach(obj => {
        this.firstThreeEvents.forEach(eventObj => {
          if (obj.month == eventObj.month) {
            if (obj.data.eventTitle.length > 2) {
              while (eventObj.data.eventTitle.length < 2) {
                for (let event of obj.data.eventTitle) {
                  if (eventObj.data.eventTitle.length < 2) {
                    eventObj.data.eventTitle.push(event);
                  }
                }
                for (let info of obj.data.eventInfo) {
                  if (eventObj.data.eventInfo.length < 2) {
                    eventObj.data.eventInfo.push(info);
                  }
                }
                for (let date of obj.data.eventDate) {
                  if (eventObj.data.eventDate.length < 2) {
                    eventObj.data.eventDate.push(date);
                  }
                }
                eventObj.data.hideBtn = true;
                if (index == 2) {
                  break;
                }
                index = index + 1;
              }
            } else {
              eventObj.data = obj.data;
              eventObj.data.hideBtn = false;
            }
          }
        });
      });
    },

    prepareProperMonth() {
      this.timelineData.forEach(timelineDataElement => {
        this.eventMonth = moment(timelineDataElement.start_date).month();

        this.timelineArray.forEach(obj => {
          if (this.eventMonth == obj.month) {
            obj.data.eventTitle.push(timelineDataElement.title);
            obj.data.eventInfo.push(timelineDataElement.description);
            obj.data.eventDate.push(timelineDataElement.start_date);
          }
        });
      });
      this.diplayOnlyFirstThreeEvents();
    },

    showMoreInfoModal(date, title, info) {
      this.moreInfoDate = moment(date).format("DD-MM-YYYY");
      this.moreInfoTitle = title;
      this.moreInfoInfo = info;
      this.$modal.show("more-info-modal");
      this.hideAllEventsModal();
    },

    showAllEventsModal(month) {
      this.timelineArray.forEach(obj => {
        if (month == obj.month) {
          this.eventList = month;
        }
      });
      this.$modal.show("all-events-modal");
      this.hideMoreInfoModal();
    },

    hideAllEventsModal() {
      this.$modal.hide("all-events-modal");
    },

    hideMoreInfoModal() {
      this.$modal.hide("more-info-modal");
    },

    setModalWidth() {
      if (this.$mq == "mobile") return "80%";
      else if (this.$mq == "tablet") return "70%";
      else if (this.$mq == "laptop") return "70%";
      else return "40%";
    },

    setModalHeight() {
      if (this.$mq == "mobile") return "30%";
      else if (this.$mq == "tablet") return "25%";
      else if (this.$mq == "laptop") return "60%";
      else return "40%";
    },

    setModalPivotX() {
      if (this.$mq == "mobile") return 0.4;
      else return 0.5;
    },

    setEventsModalWidth() {
      if (this.$mq == "mobile") return "90%";
      else if (this.$mq == "tablet") return "60%";
      else if (this.$mq == "laptop") return "50%";
      else return "40%";
    },

    setEventsModalHeight() {
      if (this.$mq == "mobile") return "auto";
      else if (this.$mq == "tablet") return "auto";
      else if (this.$mq == "laptop") return "auto";
      else if (this.$mq == "smallLaptop") return "auto";
      else return "auto";
    }
  },
  created() {
    this.getData();
  }
};
